import { generatePath, useNavigate } from 'react-router-dom';

import { useCancelOrder } from '../../order/hooks/useCancelOrder';
import { SERVICE_ROUTES } from '../service.constants';
import { API } from '../../../shared/constants';
import { getVmDetails } from '../../../shared/lib/general';
import { debug } from '../../../shared/lib/general';
import { useAppStore } from '../../../shared/hooks/useAppStore';

export const useReceiptActions = () => {
    const navigate = useNavigate();
    const order = useAppStore((s) => s.order);
    const vm = useAppStore((s) => s.vm);
    const qrCode = useAppStore((s) => s.qrCode);
    const { mutate: cancelOrderMutate } = useCancelOrder();

    const onGetReceiptHandler = (): void => {
        debug(`get receipt click ${order?.receipt_key}`, 'info');
        if (order?.receipt_key) {
            window.open(`${API.RECEIPT}?k=${order.receipt_key}`, '_blank');
        }
    };

    const onReceiptCapcha = (): void => {
        const { isCT5 } = getVmDetails(vm);
        if (order?.id) {
            !isCT5 && cancelOrderMutate(order.id);
        }
        navigate(generatePath(SERVICE_ROUTES.robot, { id: qrCode }), {
            replace: true,
        });
    };

    return {
        onGetReceiptHandler,
        onReceiptCapcha,
    };
};
